import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Validated from 'components/util/Validated';
import * as ImportForm from 'import/components/form';

class ImportFormView extends PureComponent {
  static propTypes = {
    company: PropTypes.shape({ id: PropTypes.string.isRequired }).isRequired,
    errors: PropTypes.object,
    file: PropTypes.shape({ id: PropTypes.string.isRequired, name: PropTypes.string.isRequired }),
    headersOpciones: PropTypes.array.isRequired,
    headersSelect: PropTypes.array.isRequired,
    handleFileRemove: PropTypes.func.isRequired,
    handleFileSelected: PropTypes.func.isRequired,
    handleValueChange: PropTypes.func.isRequired,
    handleHeaderChange: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    module: PropTypes.string.isRequired,
    subcompany: PropTypes.shape({ id: PropTypes.string.isRequired }).isRequired,
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.handleSubmit();
  };

  render = () => {
    return (
      <form onSubmit={this.handleSubmit}>
        <ImportForm.Files
          module={this.props.module}
          handleValueChange={this.props.handleValueChange}
          handleFileSelected={this.props.handleFileSelected}
        />

        <ImportForm.FilesPreview
          file={this.props.file}
          handleFileRemove={this.props.handleFileRemove}
        />

        {this.props.headersSelect ? (
          <ImportForm.SelectColumns
            handleHeaderChange={this.props.handleHeaderChange}
            headersOpciones={this.props.headersOpciones} //Falta el handler
            headersSelect={this.props.headersSelect} //Falta el handler
          />
        ) : null}

        <ImportForm.Buttons
          company={this.props.company}
          isLoading={this.props.isLoading}
          subcompany={this.props.subcompany}
        />
      </form>
    );
  };
}

export default Validated({
  type: 'object',
  properties: {
    file: {
      type: 'object',
    },
  },
  required: ['file'],
})(ImportFormView);



// WEBPACK FOOTER //
// src/modules/secured/modules/import/components/ImportForm.js